import Layout from '@layout/Index'

export const clbStepTemplate = [
  {
    path: '/clb-step-template',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: '',
        component: () => import(/* webpackChunkName: "step-template-form" */ './pages/ClbStepTemplateForm.vue'),
        children: [
          {
            path: 'create',
            component: () => import(/* webpackChunkName: "step-template-workspace" */ '@views/step-template/pages/StepTemplateWorkspace.vue'),
            meta: {
              title: '添加查理宝分步模板',
            },
          },
          {
            path: 'update/:id',
            component: () => import(/* webpackChunkName: "step-template-workspace" */ '@views/step-template/pages/StepTemplateWorkspace.vue'),
            meta: {
              title: '修改查理宝分步模板',
            },
          },
        ],
      },
      // {
      //   path: 'table',
      //   component: () => import(/* webpackChunkName: "clb-step-template-table" */ './pages/ClbStepTemplateTable.vue'),
      //   meta: {
      //   title: '查理宝分步模板列表',
      // },
      // },
      // {
      //   path: 'detail/:id',
      //   component: () => import(/* webpackChunkName: "clb-step-template-detail" */ './pages/ClbStepTemplateDetail.vue'),
      //   meta: {
      //   title: '查理宝分步模板详情',
      // },
      // },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/clb-step-template/clb-step-template.route.js